<div [ngClass]="{'pe-text':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{maxWidth:layoutSetting.maxWidth + 'px'}" >

  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <iframe id="ytplayer" [ngStyle]="{minHeight:item.data.playerSetting.height+ 'px'}" type="text/html"
            [src]="link"
            frameborder="0"></iframe>
  </app-sub-component-container>

</div>


